// extracted by mini-css-extract-plugin
var _1 = "MN2JR";
export { _1 as "table" }
